import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "external", "url", "use", "__overrideLangCode"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { getHubSpotLegalUrl } from '../internal/utils/getLangCodeSpecificUrls';
import { jsx as _jsx } from "react/jsx-runtime";
export const HubSpotLegalButton = _ref => {
  let {
      children = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "i18nAddon.supportLink.learnMore"
      }),
      external = true,
      url,
      use = 'link',
      __overrideLangCode
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const localeUrl = getHubSpotLegalUrl(url, __overrideLangCode);
  return /*#__PURE__*/_jsx(Button, Object.assign({}, rest, {
    external: external,
    href: localeUrl,
    use: use,
    children: children
  }));
};
export default HubSpotLegalButton;